import BasePaymentInvoice from './BasePaymentInvoice'
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls';

export default function TetPaymentInvoice() {
    const url = config.url.DSC_URL + "tet-payment-invoice-details?tpslTxnId=all";
    const incompletePath = "/PaperApplication";
    return (
        <BasePaymentInvoice apiUrl={url} incompleteProfilePath={incompletePath} />
    )
}
